import React, { PropsWithChildren, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

import { PageLoading } from '@/components/layout/routes/PageLoading.comp.tsx';
import { useUserContext } from '@/contexts/userContext/User.context.ts';
import { RouteEnum } from '@/models/route/Route.model.ts';
import {
  hasRouteAccess,
  type RequiredPermissions,
  type RequiredRoles,
} from '@/utils/permissions.util.ts';

interface Props extends PropsWithChildren {
  requiredPermissions: RequiredPermissions;
  requiredRoles?: RequiredRoles;
}

export const RouteGuard: React.FC<Props> = props => {
  const { children, requiredPermissions, requiredRoles } = props;
  const { permissions, roles } = useUserContext();
  const userPermissions = (permissions as string[]) ?? [];
  const userRoles = (roles as string[]) ?? [];

  if (!hasRouteAccess(userPermissions, userRoles, requiredPermissions, requiredRoles)) {
    return <Navigate replace to={RouteEnum.FORBIDDEN} />;
  }

  return <Suspense fallback={<PageLoading />}>{children}</Suspense>;
};
